import { Component, OnInit } from "@angular/core";
import { forkJoin } from "rxjs";
import { BaseService } from "../base.service";
import { environment } from "./../../../environments/environment";

@Component({
  selector: "app-recommended-list",
  templateUrl: "./recommended-list.component.html",
  styleUrls: ["./recommended-list.component.css"],
})
export class RecommendedListComponent implements OnInit {
  constructor(private pagesService: BaseService) {}
  apiParam = { slug: "", limit: 10, offset: 0, subslug: "" };
  shimarStatus = true;
  app_constant: any;
  loadMore: boolean;
  recommendedData: any = {};
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.app_constant = environment;
    this.getData();
  }

  getData() {
    this.loadMore = true;
    forkJoin({
      responseOne: this.pagesService.recommended(this.apiParam),
      responseTwo: this.pagesService.mostPopular(this.apiParam),
    }).subscribe(
      ({ responseOne, responseTwo }) => {
        this.shimarStatus = false;
        if (responseOne.length > 0) {
          this.recommendedData = responseOne.results;
        } else {
          this.loadMore = false;
          this.recommendedData = responseTwo.results;
        }
      },
      (err) => {
        if (err) {
          this.loadMore = false;
          this.shimarStatus = false;
        }
      }
    );
  }

  onScroll() {
    if (this.recommendedData.length > 0) {
      this.apiParam.offset += this.apiParam.offset + this.apiParam.limit;
      this.getData();
      this.loadMore = false;
    }
  }
}
